import { api } from '@/api';

export type ToolkitPromptRequestsExportResponse = Blob;

const toolkitPromptRequestsExportApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getToolkitPromptRequestsExport: builder.query<ToolkitPromptRequestsExportResponse, void>({
      query: () => ({
        url: 'debug/suggested-tools-export',
        method: 'GET',
        headers: {
          'debug-api-key': import.meta.env.VITE_DEBUG_API_KEY || '',
        },
        responseHandler: async (response) => {
          return await response.blob();
        },
        cache: 'no-cache',
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useLazyGetToolkitPromptRequestsExportQuery } = toolkitPromptRequestsExportApi;
